import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { LoadingComponentComponent } from '@shared/loading-component/loading-component.component';
import { SelectCstComponent } from './select-cst/select-cst.component';
import {CbmSelectorComponent} from '@shared/cbm-selector/cbm-selector.component';
import {SelectCbmPcabComponent} from '@shared/select-cbm-pcab/select-cbm-pcab.component';
import {SelectCbmStarsComponent} from '@shared/select-cbm-stars/select-cbm-stars.component';
import {CbmItemComponent} from '@shared/cbm-item/cbm-item.component';
import {PaginationComponent} from '@shared/pagination/pagination.component';
import {CbmDetailComponent} from '@shared/modals/cbm-detail/cbm-detail.component';
import {InfoModalComponent} from '@shared/modals/info-modal/info-modal.component';
import {SrCompleteComponent} from '@shared/modals/sr-complete/sr-complete.component';
import {ConfirmModalComponent} from '@shared/modals/confirm-custom/confirm.component';
import { CharacterCountComponent } from './character-count/character-count.component';
import { AccordionComponent } from './accordion/accordion.component';
import { StardetailsComponent } from './stardetails/stardetails.component';
import { StarratemodalComponent } from './starratemodal/starratemodal.component';




@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
      LoadingComponentComponent,
      SelectCstComponent,
      CbmSelectorComponent,
      ConfirmModalComponent,
      SrCompleteComponent,
      InfoModalComponent,
      AccordionComponent,
      StardetailsComponent,
      StarratemodalComponent,
  ],
  declarations: [
    LoadingComponentComponent,
    SelectCstComponent,
    CbmSelectorComponent,
    SelectCbmPcabComponent,
    SelectCbmStarsComponent,
    CbmItemComponent,
    PaginationComponent,
    CbmDetailComponent,
    InfoModalComponent,
    SrCompleteComponent,
    ConfirmModalComponent,
    CharacterCountComponent,
    AccordionComponent,
    StardetailsComponent,
    StarratemodalComponent,
  ]
  //rodel
})
export class SharedModule { }
